import React, { useContext } from 'react'
import { Form, Input } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
import { mobileValidator } from 'modules/utils/validators'
import { CreateEventContext } from '../../index'
import TimePicker from '../Header/DetailsFields/TimePicker'

import './index.styl'

const { Item, List } = Form

const CustomerService = () => {
  const { form, currentEventDetails } = useContext(CreateEventContext)

  return (
    <div className='customerServiceSectionContainer'>
      <div className='typeCategoryWrapper customerServiceWrapper'>
        <div className='wrapperTitleRadioText'>
          <div className='title customerServiceTitle'>Customer Service</div>
        </div>
        <div className='customerServiceBox'>
          <div className='inputRow'>
            <Item
              rules={[{ required: true, message: 'Enter Presented By' }]}
              label='Presented By'
              className='defaultInputLabel'
              name={['customerService', 'presentedBy']}
              normalize={v => v.trimStart()}
            >
              <Input />
            </Item>
            <Item
              rules={[{ required: true, message: 'Enter Email' }, { type: 'email', message: 'Please enter correct email' }]}
              label='Email'
              className='defaultInputLabel'
              name={['customerService', 'email']}
              normalize={v => v.trimStart()}
            >
              <Input />
            </Item>
          </div>
          <div className='contactPersonsTitle'>Contact</div>
          <List name={['customerService', 'contactPersons']}>
            {(fields, { add, remove }) => (
              <div className='contactPersonsWrapper'>
                {fields.map(({ key, name, ...restField }) => (
                  <div key={key} className='contactPersonRow'>
                    <div className='nameRow'>
                      <Item
                        {...restField}
                        rules={[{ required: true, message: 'Enter Name' }]}
                        label='Contact Name'
                        className='defaultInputLabel contactNameItem'
                        name={[name, 'name']}
                        normalize={v => v.trimStart()}
                      >
                        <Input />
                      </Item>
                      {fields.length > 1 && (
                        <div className='removeContactBtnWrapper'>
                          <div className='ant-form-item-label'><label>&nbsp;</label></div>
                          <div className='removeContactBtnControl'>
                            <div className='removeContactBtn' onClick={() => remove(name)}>
                              <CloseOutlined />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className='phoneHoursGroup'>
                      <Item
                        {...restField}
                        rules={[{ required: true, message: 'Enter Phone Number' }, mobileValidator]}
                        label='Phone Number'
                        className='defaultInputLabel contactPhoneItem'
                        name={[name, 'phoneNumber']}
                      >
                        <Input />
                      </Item>
                      <div className='contactHoursItem'>
                        <TimePicker
                          msTime
                          label='Contact Hours'
                          customName={[name, 'contactHours']}
                          formPath={['customerService', 'contactPersons', name, 'contactHours']}
                          requiredMessage='Contact Hours is required!'
                          time={currentEventDetails?.customerService?.contactPersons?.[name]?.contactHours}
                          form={form}
                        />
                      </div>
                    </div>
                  </div>
                ))}
                <div id='addCategory' className='addContactBtn' onClick={() => add()}>
                  Add Another Contact
                </div>
              </div>
            )}
          </List>
        </div>
      </div>
    </div>
  )
}

export default CustomerService
